<template>
  <div
    v-if="Object.keys(analysisInfo).length && analysisInfo?.content?.length"
    class="analysis-content"
  >
    <div v-for="(item, index) in analysisInfo.content" :key="index" class="analysis-content_item">
      <div v-if="!isSpecCard" class="analysis-content_header mt-12">
        <span class="type-tag">{{ item.abnormalScenarioCategory }}</span>
      </div>
      <div v-for="(el, j) in item.objectionList" :key="j" class="objection-item">
        <span>{{ j + 1 }}.</span>
        <div class="objection-item_sub">
          <p>异议内容：{{ el.abnormalContent }}</p>
          <p>
            是否待提升：
            <span :style="{ color: el.isImproved ? 'red' : '#323233' }">
              {{ el.isImproved ? '是' : '否' }}</span
            >
          </p>
          <p>依据：{{ el.accordingTo }}</p>
        </div>
      </div>
      <div v-if="item?.learning?.studyUrl" class="task-card">
        <div>{{ item.abnormalScenarioCategory }}-下一步行动</div>
        <div style="color: #248df5" @click="handleOpenUrl(item.learning.studyUrl)">去学习</div>
      </div>
    </div>
  </div>
  <template v-else>
    <Empty :empty-text="emptyText" />
  </template>
</template>

<script setup>
import { computed } from 'vue'
import { isMobile } from '@/utils'
import Empty from '@/components/Empty/index.vue'

const props = defineProps({
  analysisInfo: {
    type: Object,
    default: () => ({})
  },
  status: {
    type: [String, Number],
    default: ''
  }
})

const emit = defineEmits(['preview'])

const handleOpenUrl = (url) => {
  if (isMobile()) {
    emit('preview', url)
  } else {
    window.open(url, '_blank')
  }
}

const emptyText = computed(() => {
  if (props.status === 1) {
    return '正在分析中，预计1-2min，无需在此等待'
  }
  return '本次会话未涉及相关能力项'
})
</script>

<style lang="scss" scoped>
.analysis-content {
  margin-top: 8px;
  font-family: PingFang SC;
  display: flex;
  flex-direction: column;
  &:not(:last-child) {
    margin-bottom: 8px;
  }
  &_item {
    padding: 0 12px 12px;
    border: 1px solid #e5e6eb;
    border-radius: 8px;
    &:not(:last-child) {
      margin-bottom: 8px;
    }
  }
  &_header {
    margin-bottom: 12px;
  }
  .objection-item {
    display: flex;
    padding-left: 8px;
    &:not(:last-child) {
      margin-bottom: 2px;
    }
    &_sub {
      display: flex;
      flex-direction: column;
      margin-left: 4px;
      color: #323233;
    }
  }
  .time {
    color: #646566;
    display: inline-block;
    margin-bottom: 12px;
  }
}
.type-tag {
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  color: #323233;
  background-color: #f2f3f5;
}
.mt-12 {
  margin-top: 12px;
}
.task-card {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: #f7f8fa;
  border-radius: 8px;
  border: 1px solid #e5e6eb;
  margin-top: 12px;
  div {
    font-size: 13px;
    font-weight: 600;
    color: #323233;
  }
  a {
    cursor: pointer;
    color: #248df5;
    font-size: 13px;
  }
}
</style>
